// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueClipboard from 'vue-clipboard2'
import VueCookies from 'vue-cookies'
import App from './App'
import router from './router'
import store from './store'
import axios from 'axios'
import qs from 'qs'
import md5 from 'js-md5'
import pathUtils from './util/pathUtils'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/index.scss'

Vue.use(ElementUI)

Vue.config.productionTip = false
/* 引入复制功能 */
Vue.use(VueClipboard)
/* 引入cookie工具 */
Vue.use(VueCookies)

/**
 * axios设置
 */
const $axios = axios.create({
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
    'Accept': 'text/html, */*',
    'X-Requested-With': 'XMLHttpRequest'
  }
})

$axios.interceptors.request.use(config => {
  let requestUrl = config.url
  if (requestUrl && requestUrl.startsWith('/')) {
    if (pathUtils.isProtectedUrl(requestUrl)) {
      let accessToken = store.getters.getAccessToken
      if (accessToken) {
        config.headers['Authorization'] = accessToken
      }
    }
    config.url = pathUtils.getContextPath(requestUrl)
  }
  return config
})

$axios.interceptors.response.use(
  response => {
    if (store && response && response.data) {
      store.commit('setTimestamp', response.data.timestamp)
    }
    return response
  },
  error => {
    if (error.response.status === 401) {
      ElementUI.Message({
        message: '登陆过期，请重新登陆',
        type: 'error'
      })
      window.location.href = pathUtils.getContextPath('/')
    }
  }
)

/* 支持全局事件 */
const bus = new Vue()
Vue.prototype.$bus = bus
/* 引入ajax请求方案 */
Vue.prototype.$ajax = function (config) {
  let promise
  if (pathUtils.isProtectedUrl(config.url)) {
    promise = new Promise((resolve, reject) => {
      store.dispatch('loadAuthorization').then(() => {
        // 令牌有效
        $axios(config).then(response => {
          resolve(response)
        }, err => {
          reject(err)
        })
      }, () => {
        // 令牌失效
        let redirectPath = pathUtils.getContextPath('/')
        if (redirectPath !== window.location.pathname) {
          window.location.href = redirectPath
        } else {
          router.push({ path: '/' })
        }
      })
    })
  } else {
    promise = $axios(config)
  }
  return promise
}
Vue.prototype.$qs = qs
Vue.prototype.$md5 = md5
Vue.prototype.$extend = function () {
  return Object.assign({}, ...arguments)
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js